<template>
  <div>
    <v-btn
      icon
      @click='activate'
    >
      <v-icon class='ambia-copy'>
        {{ mdiShareVariant }}
      </v-icon>
    </v-btn>
    <v-bottom-sheet
      v-model='sheet'
      scrollable
      inset
    >
      <v-card>
        <v-card-title>
          Compartilhar aonde?
          <v-spacer />
          <v-btn
            color='secondary'
            @click='goToDocsBb()'
          >
            Ajuda
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for='tile in tiles'
              :key='tile.title'
              @click='handleShare(tile)'
            >
              <v-list-item-avatar>
                <v-avatar>
                  <img
                    :src='tile.img'
                    :alt='tile.title'
                  >
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text='tile.title' />
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-list>
            <v-list-item
              v-for='embed in embeds'
              :key='embed.title'
              @click='handleEmbed(embed)'
            >
              <v-list-item-avatar>
                <v-avatar>
                  <img
                    :src='embed.img'
                    :alt='embed.title'
                  >
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text='embed.title' />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>
<script>
import { mdiShareVariant } from '@mdi/js'
import { mapActions } from 'vuex'
import Vue from 'vue'
import Const from '@/helpers/const.js'
export default {
  name: 'Share',
  props: {
    idExperience:{
      type: String,
      default: null
    },
    experienceType:{
      type: String,
      default: null
    },
    email: {
      type: String,
      default: null
    },
    role: {
      type: String,
      default: null
    },
  },
  data: () => ({
    sheet: false,
    mdiShareVariant,
    toastOptions: {
      position: 'bottom-center',
      duration: 3000
    },
    tiles: [
      { img: require('@/assets/imgs/moodle.png'), title: 'Moodle' },
      { img: require('@/assets/imgs/blackboard.png'), title: 'Blackboard' },
      { img: require('@/assets/imgs/canvas.png'), title: 'Canvas' },
      { img: require('@/assets/imgs/d2l.png'), title: 'D2L' },
    ],
    embeds: [
      { img: require('@/assets/imgs/embed.png'), title: 'código <iframe>' },
    ]
  }),
  methods: {
    handleShare (tile) {

      if (!this.isUserAuthorized()) {

        this.sheet = false

        let text = 'Por favor, envie um email para contato@imersys.com para ter acesso'
        this.$toasted.show(text, this.toastOptions)
        return
      }

      if (tile.title == 'Blackboard') {
        this.copyToClipboardBlackboard()
      }
      else {
        this.copyToClipboardMoodleCanvasD2l()
      }
    },
    handleEmbed (embed) {

      if (!this.isUserAuthorized()) {
        this.sheet = false

        let text = 'Por favor, envie um email para contato@imersys.com para ter acesso'
        this.$toasted.show(text, this.toastOptions)
        return
      }

      if (embed.title == 'código <iframe>') {
        this.copyToClipboardIframe()
      }

    },
    activate () {
      this.sheet = true
    },
    async copyToClipboardMoodleCanvasD2l () {
      let uaIdExperience
      if (this.experienceType === '3d')
        uaIdExperience = 'https://lms.imersys.com/?viewer=' + this.idExperience
      else
        uaIdExperience = 'https://lms.imersys.com/?ua=' + this.idExperience

      try {
        await navigator.clipboard.writeText(uaIdExperience)
        let text = 'Código da experiência copiado com sucesso!'
        this.$toasted.show(text, {
          position: 'bottom-center',
          duration: 3000,
          action: {
            text: 'Ver como utilizar',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
              this.goToDocsMoodle()
            },
          }
        })
      } catch (err) {
        let text = 'Falha ao copiar o código.'
        this.$toasted.show(text, this.toastOptions)
      }
      this.sheet = false
    },
    async copyToClipboardBlackboard () {
      let uaIdExperience
      if (this.experienceType === '3d')
        uaIdExperience = 'https://lms.imersys.com/?viewer=' + this.idExperience
      else
        uaIdExperience = 'https://lms.imersys.com/?ua=' + this.idExperience

      try {
        await navigator.clipboard.writeText(uaIdExperience)
        let text = 'Código da experiência copiado com sucesso!'
        this.$toasted.show(text, {
          position: 'bottom-center',
          duration: 3000,
          action: {
            text: 'Ver como utilizar',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
              this.goToDocsBb()
            },
          }
        })
      } catch (err) {
        let text = 'Falha ao copiar o código.'
        this.$toasted.show(text, this.toastOptions)
      }
      this.sheet = false
    },


    async copyToClipboardIframe () {
      let iframe = ''
      if (this.experienceType === '3d' || this.experienceType === '360') {
        try {
          if (this.experienceType === '3d') {
            iframe = `<iframe src="${Const.AWS_CONFIG().viewerFrontEndUrl}lo/${this.idExperience}" width="100%" height="500" style="border: 0" allow="xr-spatial-tracking;gyroscope;accelerometer;fullscreen"></iframe>`
          } else {
            iframe = `<iframe id="player" src="https://player.imersys.com/video/${this.idExperience}" width="100%" height="360" style="border: 0" allow="xr-spatial-tracking;gyroscope;accelerometer;fullscreen"></iframe>`
          }
          await navigator.clipboard.writeText(iframe)
          let text = 'Código copiado com sucesso!'
          this.$toasted.show(text, {
            position: 'bottom-center',
            duration: 3000,
            action: {
              text: 'Ver como utilizar',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
                this.goToDocsIframe()
              },
            }
          })
        } catch (err) {
          let text = 'Falha ao copiar o código.'
          this.$toasted.show(text, this.toastOptions)
        }
      }
      this.sheet = false
    },
    isUserAuthorized () {
      // By default we prohibit 'democatalogo' user (the "salesman user") to
      // fetch the keys to be used within the LMS. This is an workaround scheme
      // for authorization.
      if (this.email === 'democatalogo@imersys.com' || this.role === 'guest')
        return false
      else
        return true
    },
    goToDocsBb () {
      window.open(
        'https://docs.imersys.com/docs/basic_usage/blackboard-usage.html',
        '_blank')
    },
    goToDocsMoodle () {
      window.open(
        'https://docs.imersys.com/docs/basic_usage/moodle-usage.html',
        '_blank')
    },
    goToDocsIframe () {
      window.open(
        'https://docs.imersys.com/player/integrating.html',
        '_blank')
    },
  }
}
</script>
